import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GenesysCloudService } from 'src/app/services/genesys-cloud.service';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  data_user: any = {};
  data_modal: any = {
    nombre_modal: 'Modal-Info',
    titulo: 'Prueba',
    descripcion: 'Prueba Texto',
    boton_acepta: true,
    label_acepta: '',
    boton_cerrar: false,
    label_cerrar: '',
  };

  telefono: any = '';
  cola: any = '';
  constructor(
    private genesys_services: GenesysCloudService,
    private activatedRoute: ActivatedRoute,


  ) {

   }

  ngOnInit(): void {

  }


}
